import type { IOption, IPhoneNumber } from "@interfaces";

export const PRICE_CURRENCY_OPTIONS: IOption[] = [
  { key: "IQD", value: "دینار", flag: "IQ" },
];
export const PHONE_CODE_OPTIONS: IOption<string>[] = [
  { key: "+964", value: "+964", flag: "IQ" },
  { key: "+98", value: "+98", flag: "IR" },
];
export const DEFAULT_CODE = PHONE_CODE_OPTIONS?.[0]?.key || "+98";
export const EmptyPhoneNumber: IPhoneNumber = {
  code: DEFAULT_CODE,
  number: "",
};
